export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const EDIT_NOTIFICATION = "EDIT_NOTIFICATION";

export const GET_NOTIFICATION_LOG_BY_TIMEFRAME = "GET_NOTIFICATION_LOG_BY_TIMEFRAME";
export const CLEAR_NOTIFICATION_LOG = "CLEAR_NOTIFICATION_LOG";

export const SET_SELECTED_NFID = "SET_SELECTED_NFID";
export const CLEAR_SELECTED_NFID = "CLEAR_SELECTED_NFID";